import { GraphQLService } from '@affine/core/modules/cloud';
import { mailFoldersQuery } from '@affine/graphql';
import { useService } from '@toeverything/infra';
import clsx from 'clsx';
import { useMemo } from 'react';
import useSWR from 'swr';

import * as notificationButtonStyles from './notification-button.style.css';
export const SIDEBAR_BADGE_MAX_COUNT = 99999;
export const formatSidebarBadgeCount = (
  count: number,
  maxCount = SIDEBAR_BADGE_MAX_COUNT
) => (count > maxCount ? `${maxCount}+` : String(count));

export const SidebarBadge = ({
  className,
  count,
  label,
}: {
  className?: string;
  count: number;
  label?: string;
}) => {
  if (count === 0) return null;
  return (
    <div className={clsx(notificationButtonStyles.badge, className)}>
      {label ?? formatSidebarBadgeCount(count)}
    </div>
  );
};

export const useWorkspaceMailUnreadCount = (workspaceId: string | null) => {
  const graphql = useService(GraphQLService);
  const { data: mailFolders } = useSWR(
    workspaceId ? ['sidebar-mail-unread', workspaceId] : null,
    async ([, currentWorkspaceId]) => {
      const response = await graphql.gql({
        query: mailFoldersQuery,
        variables: {
          workspaceId: currentWorkspaceId,
          accountId: null,
        },
      });
      return response.mailFolders;
    },
    { suspense: false }
  );

  return useMemo(
    () =>
      (mailFolders ?? []).reduce(
        (total, folder) => total + folder.unreadCount,
        0
      ),
    [mailFolders]
  );
};
